import React from 'react';
import styled from 'styled-components';

const ModuleListItemsDiv = styled.div((props) => props.$styleText);

export const ModuleListItems = (componentProps) => {
  return (
    <ModuleListItemsDiv className={componentProps.className ?? ''} $styleText={componentProps.styleText} style={componentProps.style}>
      {componentProps.children}
    </ModuleListItemsDiv>
  );
};
